/** 管理后台单文件上传上限，按现有二进制 MB 口径计算。 */
const ADMIN_UPLOAD_FILE_LIMIT_MB = 30

/** 管理后台多文件单次提交的业务总量上限。 */
const ADMIN_UPLOAD_BATCH_LIMIT_MB = 150

const BYTES_PER_MB = 1024 * 1024
const ADMIN_UPLOAD_FILE_LIMIT_BYTES = ADMIN_UPLOAD_FILE_LIMIT_MB * BYTES_PER_MB
const ADMIN_UPLOAD_BATCH_LIMIT_BYTES = ADMIN_UPLOAD_BATCH_LIMIT_MB * BYTES_PER_MB

/** 返回单文件大小错误；空字符串表示校验通过。 */
function adminUploadFileSizeError(file) {
  if (file && Number(file.size || 0) > ADMIN_UPLOAD_FILE_LIMIT_BYTES) {
    return `单文件不能超过 ${ADMIN_UPLOAD_FILE_LIMIT_MB}MB`
  }
  return ''
}

/** 返回多文件总量错误；空字符串表示校验通过。 */
function adminUploadBatchSizeError(files = []) {
  const totalSize = Array.from(files || []).reduce((sum, file) => sum + Number(file && file.size || 0), 0)
  if (totalSize > ADMIN_UPLOAD_BATCH_LIMIT_BYTES) {
    return `单次上传文件总大小不能超过 ${ADMIN_UPLOAD_BATCH_LIMIT_MB}MB`
  }
  return ''
}

/** API 层兜底校验，避免绕过上传组件直接发起超限请求。 */
function assertAdminUploadFiles(files = [], options = {}) {
  const normalizedFiles = Array.from(files || []).filter(Boolean)
  for (const file of normalizedFiles) {
    const fileError = adminUploadFileSizeError(file)
    if (fileError) throw new Error(fileError)
  }
  if (options.checkBatch !== false) {
    const batchError = adminUploadBatchSizeError(normalizedFiles)
    if (batchError) throw new Error(batchError)
  }
}

module.exports = {
  ADMIN_UPLOAD_FILE_LIMIT_MB,
  ADMIN_UPLOAD_BATCH_LIMIT_MB,
  ADMIN_UPLOAD_FILE_LIMIT_BYTES,
  ADMIN_UPLOAD_BATCH_LIMIT_BYTES,
  adminUploadFileSizeError,
  adminUploadBatchSizeError,
  assertAdminUploadFiles,
}
